import React from 'react'
import { Box, Flex } from 'pcln-design-system'
import styled, { keyframes } from 'styled-components'

const FlexHeight = styled(Flex)`
  height: 500px;
  background: white;
`

const stretch = keyframes`
  0% {
    transform: scale(.2);
  }
  100% {
    transform: scale(1);
  }
`

const determineAnimationDelay = num => num === 1
  ? '0s'
  : num === 2
    ? '0.2s'
    : (num === 3 ? '0.4s' : null)

const DotBox = styled(Box)`
  display: inline-block;
  background-color: #007aff;
  height: 15px;
  width: 15px;
  border-radius: 25px;
  margin-right: 60px;
  margin-top: 100px;
  animation-name: ${stretch};
  animation-duration: 0.6s; 
  animation-timing-function: ease-out; 
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-delay: ${props => determineAnimationDelay(props.number)};
`
const numerOfDots = [1, 2, 3]

export default class LoaderCSS extends React.Component {
  render () {
    return (
      <FlexHeight alignItems='flex-start' justifyContent='center'>
        {React.Children.map(numerOfDots, i => <DotBox key={i} number={i} />)}
      </FlexHeight>
    )
  }
}
